/**
 * 親windowからpostMessageで"action: exposeExtendData"が飛んできた際の処理を担う
 * 本来的にAPIには存在しない情報を(タグやカスタムフィールドなど)liquid側から取得するためのもので
 * 特殊な要件の際にはこちらに追加されたデータを参照し要件を満たすことを想定
 */
import { useState, useEffect } from 'react';

export const useGetExposeExtendDataFromParent = () => {

  const [extendData, setExtendData] = useState<ExtendData>();

  useEffect(() => {
    const handleRecieveMessage = async (event: MessageEvent) => {

      const { action, extendData } = event.data as ExposeExtendDataMessage;

      if (action !== 'exposeExtendData') return;

      setExtendData(extendData);
      window.removeEventListener('message', handleRecieveMessage);
    };
    window.addEventListener('message', handleRecieveMessage);

    return () => window.removeEventListener('message', handleRecieveMessage);
  }, []);

  return extendData;
};

// types

export type ExposeExtendDataMessage = {
  action: 'exposeExtendData',
  extendData: ExtendData
}
export type ExtendData = {
  user: ExtendDateUser,
  showProducts: ExtendDataShowProduct[]
  contractProduct: ExtendDataContractProduct
  presaleProducts: ExtendDataPresaleProduct[]
  items: ExtendDataItem[]
} 
type ExtendDateUser = {
  tags: string[]
}
type ExtendDataShowProduct = {
  type: 'Static' | 'Random',
  image: string | null,
  title: string | null,
  text: string | null,
  quantity: number | null
}
type ExtendDataPresaleProduct = {
  title: string,
  url: string,
  image: string | null,
  tags: string[],
  price: number
}
type ExtendDataContractProduct = {
  title: string,
  variantId: string,
  image: string | null,
  sellingPlanId: string,
  price: number,
  subscriptionPrice: number,
}
type ExtendDataItem = {
  title: string,
  variantId: string,
  sellingPlanId: string,
  price: number,
  planPrice: number,
  maxQuantity: number,
  minQuantity: number
}